//Appointments modules
import styles from "../../styles/appointments/AppointmentsCron.module.css"

//Prime React
import { Checkbox } from "primereact/checkbox"

//utils
import { weekDays } from "./utils"

export default function AppointmentsFormCronWeekly({
  activeWeekDays,
  onSetActiveWeekDays,
}) {
  return (
    <div>
      <div>Weekly options: </div>
      <div className={styles.weeklyContainer}>
        {weekDays.map((day, index) => (
          <div
            className={`${styles.cronOption} ${styles.weeklyOption}`}
            key={index}
          >
            <Checkbox
              checked={activeWeekDays[day.value]}
              onChange={(e) => {
                const newWeekDays = { ...activeWeekDays }
                newWeekDays[day.value] = e.checked
                onSetActiveWeekDays(newWeekDays)
              }}
              className={styles.cronOptionPortion}
            />
            <span className={styles.cronOptionPortion}>{day.name}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
